import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';

const userAdapter = createEntityAdapter({
  selectId: (e) => e.userId,
});

const initialState = userAdapter.getInitialState();

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query({
      query: () => ({
        url: `/users`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      providesTags: ['User'],
    }),
    addEditUser: builder.mutation({
      query: () => ({
        url: '/users',
        method: 'POST',
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'User', id: 'LIST' }],
    }),
    addEmergencyContact: builder.mutation({
      query: (contactDetails) => ({
        url: '/users/emergency-contact',
        method: 'POST',
        body: { ...contactDetails },
      }),
      invalidatesTags: ['User'],
    }),
    updateEmergencyContact: builder.mutation({
      query: (contactDetails) => ({
        url: '/users/emergency-contact',
        method: 'PATCH',
        body: { ...contactDetails },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useAddEditUserMutation,
  useAddEmergencyContactMutation,
  useUpdateEmergencyContactMutation,
} = usersApiSlice;
